import React from 'react';

interface ContentPageProps {
    children: React.ReactNode;
    className?: string;
}

export const ContentPage: React.FC<ContentPageProps> = ({ children, className }) => {
    const baseClasses = 'mx-auto pt-4 pb-4 max-w-4xl p-2';
    const combinedClasses = `${baseClasses} ${className || ''}`;

    return <div className={combinedClasses}>{children}</div>;
};
